import * as React from 'react';
import { connect } from 'react-redux';

import {
  NewBuildingsServiceBlock,
} from '../../components/service_block/new_buildings_service_block';
import { IPromo } from '../../models/promo';
import { IMainPage } from '../../models/mainpage';
import { trackService } from '../../helpers/metrics_helper';

interface IProps {
  promo: IPromo[];
}

class NewBuildingsServicesComponent extends React.Component<IProps> {
  public render() {
    if (this.props.promo.length > 0) {
      return (
        <NewBuildingsServiceBlock
            onAdsClick={(eventLabel: string) => trackService(eventLabel)}/>
      );
    } else {
      return (<div/>);
    }
  }
}

export const NewBuildingsServices = connect<IProps, {}, {}>((state: {
    mainpage: IMainPage,
  }) => ({
  promo: state.mainpage.promoBlocks,
}))(NewBuildingsServicesComponent);
